import React, { useEffect, useState } from 'react'
import { Container, TextBody, ToastContext } from '@pmi/pmi-iqos-ds-react'
import {
  analytics,
  cookie,
  formatProductUrl,
  dispatchPopupPromotionAlreadyUsed,
  getRoute,
  goToRoute
} from '@pmi/pmi-iqos-shared-react'
import { ProductCardGeneric } from '@dcx-common/components'

const ProductCardProduct = ({
  product,
  translations,
  loading,
  noDetailLink,
  onAddToCart,
  onAddToPreorder,
  productPosition,
  mainCategoryName,
  isShortDescription,
  ...rest
}) => {
  const [isAddingToCart, setIsAddingToCart] = useState(false)
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(
    product.options ? product.selectedOptionIndex || 0 : null
  )
  const toastContext = ToastContext.getContextActions()
  const popupToast = toastContext.popupToast

  useEffect(() => {
    if (
      product &&
      product.selectedOptionIndex !== undefined &&
      product.selectedOptionIndex !== selectedOptionIndex
    )
      setSelectedOptionIndex(product.selectedOptionIndex)
  }, [product])

  const handleAddToCart = async () => {
    setIsAddingToCart(true)
    if (selectedOptionIndex !== null && selectedOptionIndex !== undefined) {
      onAddToCart && (await onAddToCart(product, selectedOptionIndex))
    }
    setIsAddingToCart(false)
    analytics.addToCart(product, selectedOptionIndex, 1)

    const variant = options && options[selectedOptionIndex]
    analytics.onProductLineUpClick({
      eventCategory: mainCategoryName,
      eventLabel: `Add to Cart - ${variant.variantName}`
    })
  }

  const handleChangeColor = newSelectedOptionIndex => {
    if (selectedOptionIndex !== newSelectedOptionIndex) {
      setSelectedOptionIndex(newSelectedOptionIndex)
      dispatchPopupPromotionAlreadyUsed(
        cookie.getSpiceId(),
        [
          {
            options: product.options,

            selectedOptionIndex: newSelectedOptionIndex
          }
        ],
        popupToast,
        translations,
        Container,
        TextBody
      )
      analytics.productImpression(
        product,
        newSelectedOptionIndex,
        productPosition,
        mainCategoryName
      )
    }
  }

  const handleOnCardClick = () => {
    analytics.productClick(
      product,
      selectedOptionIndex,
      productPosition,
      mainCategoryName
    )
  }

  const handle3dClick = () => {
    const variant =
      options && options[selectedOptionIndex] && options[selectedOptionIndex]

    analytics.onProductLineUpClick({
      eventCategory: mainCategoryName,
      eventLabel: `Start 3D Mode - ${variant.variantName}`
    })

    window.dispatchEvent(
      new window.CustomEvent('player3d:show', {
        detail: {
          productId: product.id,
          variantId: variant.variantId
        }
      })
    )
  }

  const handlePDPClick = () => {
    goToRoute({
      mainPath: getRoute(
        formatProductUrl(
          product,
          product.options[selectedOptionIndex],
          selectedOptionIndex === 0
        ),
        true
      )
    })

    const variant =
      options && options[selectedOptionIndex] && options[selectedOptionIndex]
    analytics.onProductLineUpClick({
      eventCategory: mainCategoryName,
      eventLabel: `View Details - ${variant.variantName}`
    })
  }

  const handleAddToPreorder = async () => {
    setIsAddingToCart(true)
    if (selectedOptionIndex !== null && selectedOptionIndex !== undefined) {
      analytics.notifyMe(
        'Click',
        'PLP Notify Me',
        product.options[selectedOptionIndex].variantId,
        product.options[selectedOptionIndex].variantName
      )
      await onAddToPreorder(product, selectedOptionIndex)
    }
    setIsAddingToCart(false)
  }

  const { options } = product
  const { stock, price, listPrice, images, badge, currency, shortDescription } =
    options[selectedOptionIndex]

  const bazaarVoice = product ? product.bv : null
  const bazaarVoiceProductId = options
    ? options[selectedOptionIndex].bv_id
    : bazaarVoice
    ? bazaarVoice.bv_id
    : null
  const bazaarVoiceShowRating =
    bazaarVoice && bazaarVoice.display_rating === true && bazaarVoiceProductId

  return (
    <ProductCardGeneric
      hasBadge
      href={
        noDetailLink
          ? null
          : getRoute(
              formatProductUrl(
                product,
                product.options[selectedOptionIndex],
                selectedOptionIndex === 0
              ),
              true
            )
      }
      handleAddToPreorder={handleAddToPreorder}
      handleOnCardClick={handleOnCardClick}
      handleChangeColor={handleChangeColor}
      handleAddToCart={handleAddToCart}
      handle3dClick={product.model3D && handle3dClick}
      handlePDPClick={handlePDPClick}
      selectedOptionIndex={selectedOptionIndex}
      translations={translations}
      buttonAddToPreorderLabel={translations.tk_buttonPreorder}
      buttonAddToCartLabel={translations.tk_buttonAddToCart}
      title={product.name}
      shortDescription={shortDescription}
      alternativeBadge={badge}
      loading={isAddingToCart || loading}
      stock={stock}
      price={price}
      listPrice={listPrice}
      currency={currency}
      images={images}
      options={options}
      testingPrefix="ProductList"
      bazaarVoiceProductId={bazaarVoiceShowRating ? bazaarVoiceProductId : null}
      outOfStockAction={product.outOfStockAction}
      isShortDescription={isShortDescription}
      {...rest}
    />
  )
}

export default ProductCardProduct
